import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Alert } from '@app/models';

import { AuthenticationService, LocalService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NoGuard implements CanActivate {
  toast = new Alert();

  access: boolean;

  constructor(
    public translate: TranslateService,
    private authenticationService: AuthenticationService, 
    private localService: LocalService
  ) { }

  // Permission d'acces vers la route
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkLogin(); 
  }

  // Vérification du statut d'authentification
  checkLogin(): any {
    const user = this.localService.getJsonValue('currentUtilisateur');
    if (user) {
      this.authenticationService.redirectByRole(null, false, user.role_id);
    }
    
    return true;
  }
}